export default function About() {
  const points = [
    {
      icon: "ri-search-eye-line",
      title: "精挑细选",
      desc: "编辑团队逐部审核收录，只把真正好看的狗狗主角动画与动物拟人番带给萌宠控。",
    },
    {
      icon: "ri-list-ordered-2",
      title: "人气排序",
      desc: "评分与追番人数实时联动，人气榜单 24 小时刷新，热门作品永远排在最前。",
    },
    {
      icon: "ri-community-line",
      title: "同好社区",
      desc: "围绕猫狗动画与兽耳萌番建立讨论氛围，让每个毛茸茸爱好者都有归属感。",
    },
    {
      icon: "ri-verified-badge-line",
      title: "正版倡导",
      desc: "坚持为正版内容导流，所有观看入口均跳转官方授权平台，守护创作者。",
    },
  ];

  return (
    <section id="about" className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
        <div className="order-2 lg:order-1">
          <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-700">
            <i className="ri-footprint-fill"></i>
            关于我们
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl text-foreground-950">
            为每一只毛茸茸的主角而生
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            「小狗看番」是一个专注狗狗主角、动物拟人、兽耳萌系与宠物日常动画的垂直内容站。
            我们相信，屏幕上那些摇着尾巴、竖起耳朵的小家伙，值得被认真整理与推荐。
            无论你是喜欢柴犬日常的治愈系观众，还是沉迷兽耳学园设定的萌番老粉，
            这里都能帮你更快找到下一部合口味的作品。
          </p>
          <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
            我们坚持：每一部收录的番剧都经过人工审核，内容介绍真实准确，评分排序公开透明，
            并始终为原创与正版站台。
          </p>

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {points.map((p) => (
              <div
                key={p.title}
                className="flex gap-3 rounded-2xl bg-background-100 border border-background-200/70 p-4"
              >
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-primary-100 text-primary-700 text-lg">
                  <i className={p.icon}></i>
                </span>
                <div>
                  <h3 className="font-semibold text-foreground-950">{p.title}</h3>
                  <p className="mt-1 text-xs md:text-sm text-foreground-600 leading-relaxed">{p.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="order-1 lg:order-2 relative">
          <div className="overflow-hidden rounded-3xl border border-background-200/70">
            <img
              src="https://readdy.ai/api/search-image?query=Group%20of%20adorable%20anime%20dogs%20and%20animal%20ears%20characters%20hugging%20together%20on%20a%20cozy%20sofa%2C%20warm%20golden%20living%20room%20light%2C%20corgi%20shiba%20kitten%20fox%20friends%2C%20heartwarming%20community%20vibe%2C%20soft%20cream%20palette%2C%20stylish%20anime%20illustration%2C%20high%20detail&width=900&height=1100&seq=xg-about-2026&orientation=portrait"
              alt="小狗看番的萌宠主角们"
              className="h-full w-full object-cover"
            />
          </div>
          <div className="absolute -bottom-5 left-1/2 -translate-x-1/2 flex items-center gap-3 rounded-2xl bg-background-50 border border-background-200/80 px-5 py-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent-500 text-background-50 text-lg">
              <i className="ri-heart-3-fill"></i>
            </span>
            <div>
              <p className="font-heading text-foreground-950">与毛茸茸同行</p>
              <p className="text-xs text-foreground-500">让每一份萌都被看见</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}